<template>
  <v-content class="pa-0">
    <v-card-title class="grey lighten-3">
      <v-row>
        <v-icon class="draggable">mdi-drag</v-icon>
        <v-col class="py-0">{{ statusLabel }}</v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex sm12>
            <v-text-field
              label="Name"
              v-model="s.name"
              @input="$v.s.name.$touch()"
              @blur="$v.s.name.$touch()"
              :error-messages="nameErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-content>
</template>

<script>
import {
  INTERNAL_STATUS_UPDATE_MUTATION,
  INTERNAL_STATUS_CREATE_MUTATION,
} from "../../../../constants/graphql";
import TaxesListSelect from "../../shared/TaxesListSelect";
import { required } from "vuelidate/lib/validators";

export default {
  name: "InternalStatusEditor",

  components: {
    TaxesListSelect,
  },

  props: {
    status: {
      type: Object,
      default: () => ({}),
    },

    doSaveStatus: {
      type: Boolean,
      default: false,
    },

    statusEditorDialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      s: { ...this.status },
      debug: false,
    };
  },

  methods: {
    saveStatus() {
      this.$emit("onResetSave");
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let mutation =
          this.context == "edit"
            ? INTERNAL_STATUS_UPDATE_MUTATION
            : INTERNAL_STATUS_CREATE_MUTATION;
        this.$apollo
          .mutate({
            mutation: mutation,
            variables: {
              ...this.s,
            },
          })
          .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
      }
    },
    saveGqlObjectHandler(result) {
      this.$emit("saved", this.context);
    },
    saveGqlObjectErrorHandler(err) {
      const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
      this.$store.dispatch("showAppSnackbar", {
        msg: errorMsg,
        color: "error",
      });
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    statusLabel() {
      return this.status.id != null ? this.status.name : "New Internal Status";
    },
    context() {
      return this.status.id != null ? "edit" : "create";
    },
    nameErrors() {
      let errors = [];
      if (!this.$v.s.name.$dirty) {
        return errors;
      }
      if (!this.$v.s.name.required) {
        errors.push("Name is required.");
      }
      return errors;
    },
  },

  watch: {
    status(data) {
      let status = { ...data };
      delete status.__typename;
      this.s = status;
    },
    statusEditorDialog(value) {
      if (!value) {
        this.s = {};
        this.$v.$reset();
      }
    },
    doSaveStatus(value) {
      if (value) {
        this.saveStatus();
      }
    },
  },
  validations: {
    s: {
      name: { required },
    },
  },
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/gt/admin/department-types/InternalStatusEditor.vue